<div class="select-content-container">
	<div class="select-content-title-container">
		<span class="title-description" translate>dashboard.condition</span>
		<copo-slide-button labelAfter="dashboard.steelgrade"
							labelBefore="dashboard.customer-material-reference"
							(toggleChange)="onToggleChange($event)"
							[checked]="!customerArticleSelected"
		></copo-slide-button>
	</div>

	<div class="select-content-subtitle" translate>dashboard.drag-drop-information</div>
	<div class="select-content-lists">
		<div class="drag-drop-container">
			<mat-form-field class="transversal-header-search input-title-field-rts" appearance="outline" subscriptSizing="dynamic">
				<mat-icon svgIcon="search" class="transversal-header-search-icon" matPrefix></mat-icon>
				<input
						[placeholder]="'search.placeholder' | translate"
						matInput
						type="text"
						spellcheck="false"
						[formControl]="searchTextControl"/>
			</mat-form-field>
			<div class="drag-drop-list-rts"
				cdkDropList
				#availableContainterList="cdkDropList"
				[cdkDropListData]="scroller.list"
				[cdkDropListConnectedTo]="[selectedContainerList]"
				(cdkDropListDropped)="drop($event)"
				copoVirtualScroller
				[dataId]="dataId"
				cdkDropListSortingDisabled
				#scroller="copoVirtualScroller"
				(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)"
				cdkScrollable>
				<ng-container *ngFor="let batch of scroller.list">
					<div class="content-item-row"
						[style.display]="isSelectedContinsItem(batch) ? 'none' : ''"
						[cdkDragDisabled]="maxItemLimit()"
						cdkDrag>
						<div *ngIf="customerArticleSelected">{{ batch.customerArticleReference ? batch.customerArticleReference : ('dashboard.without-value' | translate) }}</div>
						<div *ngIf="!customerArticleSelected">{{ batch.steelgradeDescription ? batch.steelgradeDescription : ('dashboard.without-value' | translate) }}</div>
						<mat-icon class="icon-item-element align-item-right" svgIcon="md:menu"></mat-icon>
					</div>
				</ng-container>
				<copo-loading-spinner *ngIf="scroller.loading"></copo-loading-spinner>
			</div>
		</div>
		<div class="drag-drop-container">
			<div class="drag-drop-title label-orange-color"> {{ (customerArticleSelected ? 'dashboard.drag-customer-article-here' : 'dashboard.drag-steelgrades-here') | translate }}</div>
			<div class="drag-drop-sub-title">{{this.selectedItemList.length}}/{{MAX_ITEM_COUNT}}</div>
			<div class="drop-list-box-rts"
				cdkDropList
				#selectedContainerList="cdkDropList"
				[cdkDropListData]="selectedItemList"
				[cdkDropListConnectedTo]="[availableContainterList]"
				(cdkDropListDropped)="drop($event)">
				<div class="content-item-row-selected" *ngFor="let batch of selectedItemList" cdkDrag>
					<div *ngIf="customerArticleSelected">{{ batch.customerArticleReference ? batch.customerArticleReference : ('dashboard.without-value' | translate) }}</div>
					<div *ngIf="!customerArticleSelected">{{ batch.steelgradeDescription ? batch.steelgradeDescription : ('dashboard.without-value' | translate) }}</div>
					<mat-icon class="icon-item-element" svgIcon="md:menu"></mat-icon>
				</div>
			</div>
		</div>
	</div>

</div>
